import {getSanitizedJsonAndParse} from './utils/get_sanitized_json_and_parse';

export const ezGlobals = getSanitizedJsonAndParse('ez-globals', {params: {}});
